import { Button } from "@/components/ui/button";
import { useSidebar } from "@/components/ui/sidebar";
import { useMobileHeaderOptions } from "@/hooks/useMobileHeader";
import { useTranslation } from "@/hooks/useTranslation";
import { ArrowLeftIcon, MenuIcon } from "lucide-react";

/**
 * The bar at the top of every mobile screen, as in the Claude app: the menu
 * button that opens the sidebar — or a back arrow on a drill-down screen — and
 * the screen's title, centred. Nothing on the right: no action belongs to every
 * screen.
 */
export function MobileHeader() {
  const { t } = useTranslation();
  const { setOpenMobile } = useSidebar();
  const { title, onBack, isMenuDisabled } = useMobileHeaderOptions();

  return (
    <header className="grid relative z-20 shrink-0 grid-cols-[3rem_1fr_3rem] items-center px-2 h-14 select-none bg-background">
      {onBack ? (
        <Button
          variant="ghost"
          size="icon"
          className="rounded-full size-11"
          aria-label={t("common.back")}
          onClick={onBack}
        >
          <ArrowLeftIcon className="size-5" />
        </Button>
      ) : (
        <Button
          variant="ghost"
          size="icon"
          className="rounded-full size-11"
          aria-label={t("components.mobileShell.openMenu")}
          disabled={isMenuDisabled}
          onClick={() => setOpenMobile(true)}
        >
          <MenuIcon className="size-5" />
        </Button>
      )}
      <h1 className="text-base font-semibold text-center truncate">{title}</h1>
    </header>
  );
}
